import { useQuery } from 'react-query';
import { useBuildingIdAtom } from 'stores/building-id-atom';

import { axiosInstance } from '../axiosInstance';

export interface PdfData {
  name: string;
  date: number;
  file: string;
  id: number;
}

export const getPdfsQueryKey = (buildingId: number | null) => ['pdfs', buildingId];

const getPdfs = async (buildingId: number | null) => {
  const { data } = await axiosInstance.get<PdfData[]>(`/training-pdfs/${buildingId}?limit=10`, {});
  return data;
};

export const useGetPdfs = () => {
  const [buildingId] = useBuildingIdAtom();

  return useQuery({
    enabled: !!buildingId,
    queryKey: getPdfsQueryKey(buildingId),
    queryFn: () => getPdfs(buildingId),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
